import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import { SyncBlockError } from '../common/types';
import { resolveSyncBlockInstance } from '../utils/resolveSyncBlockInstance';
import { createSyncBlockNode } from '../utils/utils';

// A store manager responsible for the lifecycle and state management of reference sync blocks in an editor instance.
// Designed to manage local in-memory state and synchronize with an external data provider.
// Supports fetch, cache, and subscription for sync block data.
// Handles fetching source URL and title for sync blocks.
// Can be used in both editor and renderer contexts.
export var ReferenceSyncBlockStoreManager = /*#__PURE__*/function () {
  function ReferenceSyncBlockStoreManager(dataProvider) {
    _classCallCheck(this, ReferenceSyncBlockStoreManager);
    _defineProperty(this, "isRefreshingSubscriptions", false);
    this.syncBlockCache = new Map();
    this.subscriptions = new Map();
    this.titleSubscriptions = new Map();
    this.dataProvider = dataProvider;
    this.syncBlockURLRequests = new Map();
    this.providerFactories = new Map();
  }

  /**
   * Refreshes the subscriptions for all sync blocks.
   * @returns {Promise<void>}
   */
  return _createClass(ReferenceSyncBlockStoreManager, [{
    key: "refreshSubscriptions",
    value: (function () {
      var _refreshSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var syncBlocks, _iterator, _step, _loop;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isRefreshingSubscriptions) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              this.isRefreshingSubscriptions = true;
              syncBlocks = [];
              _iterator = _createForOfIteratorHelper(this.subscriptions.entries());
              _context2.prev = 5;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var _step$value, resourceId, callbacks;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _step$value = _slicedToArray(_step.value, 2), resourceId = _step$value[0], callbacks = _step$value[1];
                      Object.keys(callbacks).forEach(function (localId) {
                        syncBlocks.push(createSyncBlockNode(localId, resourceId));
                      });
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context2.next = 12;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 10);
            case 10:
              _context2.next = 8;
              break;
            case 12:
              _context2.next = 17;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t1 = _context2["catch"](5);
              _iterator.e(_context2.t1);
            case 17:
              _context2.prev = 17;
              _iterator.f();
              return _context2.finish(17);
            case 20:
              _context2.prev = 20;
              _context2.next = 23;
              return this.fetchSyncBlocksData(syncBlocks);
            case 23:
              _context2.next = 27;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t2 = _context2["catch"](20);
            case 27:
              _context2.prev = 27;
              this.isRefreshingSubscriptions = false;
              return _context2.finish(27);
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[5, 14, 17, 20], [20, 25, 27, 30]]);
      }));
      function refreshSubscriptions() {
        return _refreshSubscriptions.apply(this, arguments);
      }
      return refreshSubscriptions;
    }())
  }, {
    key: "fetchSyncBlockSourceInfo",
    value: function fetchSyncBlockSourceInfo(resourceId) {
      var _existingSyncBlock$da,
        _existingSyncBlock$da2,
        _this = this;
      if (!resourceId || !this.dataProvider) {
        return;
      }
      if (this.syncBlockURLRequests.get(resourceId)) {
        return;
      }
      this.syncBlockURLRequests.set(resourceId, true);
      var existingSyncBlock = this.getFromCache(resourceId);
      if (!existingSyncBlock) {
        return;
      }

      // skip if source URL and title are already present
      if ((_existingSyncBlock$da = existingSyncBlock.data) !== null && _existingSyncBlock$da !== void 0 && _existingSyncBlock$da.sourceURL && (_existingSyncBlock$da2 = existingSyncBlock.data) !== null && _existingSyncBlock$da2 !== void 0 && _existingSyncBlock$da2.sourceTitle) {
        return;
      }
      var _ref = existingSyncBlock.data || {},
        sourceAri = _ref.sourceAri,
        product = _ref.product,
        blockInstanceId = _ref.blockInstanceId;
      if (!sourceAri || !product || !blockInstanceId) {
        return;
      }
      this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product).then(function (sourceInfo) {
        if (!sourceInfo) {
          return;
        }
        _this.updateCacheWithSourceInfo(resourceId, sourceInfo);
        if (sourceInfo.title) {
          _this.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
        }
      }).finally(function () {
        _this.syncBlockURLRequests.delete(resourceId);
      });
    }

    /**
     * Fetch sync block data for a given array of sync block nodes.
     * @param syncBlockNodes - The array of sync block nodes to fetch data for
     * @returns The fetched sync block data results
     */
  }, {
    key: "fetchSyncBlocksData",
    value: (function () {
      var _fetchSyncBlocksData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(syncBlockNodes) {
        var _this2 = this;
        var nodesToFetch, blocksWithNotFoundError, data, resolvedData;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(syncBlockNodes.length === 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", Promise.resolve([]));
            case 2:
              if (this.dataProvider) {
                _context3.next = 4;
                break;
              }
              throw new Error('Data provider not set');
            case 4:
              // Don't fetch for not_found error since the source is already deleted
              nodesToFetch = [], blocksWithNotFoundError = [];
              syncBlockNodes.forEach(function (node) {
                var existingSyncBlock = _this2.getFromCache(node.attrs.resourceId);
                if ((existingSyncBlock === null || existingSyncBlock === void 0 ? void 0 : existingSyncBlock.error) === SyncBlockError.NotFound) {
                  blocksWithNotFoundError.push(existingSyncBlock);
                } else {
                  nodesToFetch.push(node);
                }
              });
              _context3.next = 8;
              return this.dataProvider.fetchNodesData(nodesToFetch);
            case 8:
              data = _context3.sent;
              if (data) {
                _context3.next = 11;
                break;
              }
              throw new Error('Failed to fetch sync block node data');
            case 11:
              resolvedData = [];
              data.forEach(function (syncBlockInstance) {
                if (!syncBlockInstance.resourceId) {
                  return;
                }
                if (syncBlockInstance.error) {
                  _this2.updateCache(syncBlockInstance);
                  resolvedData.push(syncBlockInstance);
                  return;
                }
                var existingSyncBlock = _this2.getFromCache(syncBlockInstance.resourceId);
                var resolvedSyncBlockInstance = existingSyncBlock ? resolveSyncBlockInstance(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
                _this2.updateCache(resolvedSyncBlockInstance);
                resolvedData.push(resolvedSyncBlockInstance);
                _this2.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
              });
              return _context3.abrupt("return", [].concat(resolvedData, blocksWithNotFoundError));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function fetchSyncBlocksData(_x) {
        return _fetchSyncBlocksData.apply(this, arguments);
      }
      return fetchSyncBlocksData;
    }())
  }, {
    key: "updateCacheWithSourceInfo",
    value: function updateCacheWithSourceInfo(resourceId, sourceInfo) {
      var existingSyncBlock = this.getFromCache(resourceId);
      if (existingSyncBlock && existingSyncBlock.data) {
        existingSyncBlock.data.sourceURL = sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.url;
        existingSyncBlock.data = _objectSpread(_objectSpread({}, existingSyncBlock.data), {}, {
          sourceURL: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.url,
          sourceTitle: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.title
        });
        this.updateCache(existingSyncBlock);
      }
    }
  }, {
    key: "updateCache",
    value: function updateCache(syncBlock) {
      var resourceId = syncBlock.resourceId;
      if (resourceId) {
        this.syncBlockCache.set(resourceId, syncBlock);
        var callbacks = this.subscriptions.get(resourceId);
        if (callbacks) {
          Object.values(callbacks).forEach(function (callback) {
            callback(syncBlock);
          });
        }
      }
    }
  }, {
    key: "updateSourceTitleSubscriptions",
    value: function updateSourceTitleSubscriptions(resourceId, title) {
      var callbacks = this.titleSubscriptions.get(resourceId);
      if (callbacks) {
        Object.values(callbacks).forEach(function (callback) {
          callback(title);
        });
      }
    }
  }, {
    key: "getFromCache",
    value: function getFromCache(resourceId) {
      return this.syncBlockCache.get(resourceId);
    }
  }, {
    key: "deleteFromCache",
    value: function deleteFromCache(resourceId) {
      this.syncBlockCache.delete(resourceId);
      this.providerFactories.delete(resourceId);
    }
  }, {
    key: "subscribeToSyncBlock",
    value: function subscribeToSyncBlock(resourceId, localId, callback) {
      var _this3 = this;
      // add to subscriptions map
      var resourceSubscriptions = this.subscriptions.get(resourceId) || {};
      this.subscriptions.set(resourceId, _objectSpread(_objectSpread({}, resourceSubscriptions), {}, _defineProperty({}, localId, callback)));

      // call the callback immediately if we have cached data
      var cachedData = this.getFromCache(resourceId);
      if (cachedData) {
        callback(cachedData);
      } else {
        this.fetchSyncBlocksData([createSyncBlockNode(localId, resourceId)]).catch(function () {});
      }
      return function () {
        var resourceSubscriptions = _this3.subscriptions.get(resourceId);
        if (resourceSubscriptions) {
          delete resourceSubscriptions[localId];
          if (Object.keys(resourceSubscriptions).length === 0) {
            _this3.subscriptions.delete(resourceId);
            _this3.deleteFromCache(resourceId);
          } else {
            _this3.subscriptions.set(resourceId, resourceSubscriptions);
          }
        }
      };
    }
  }, {
    key: "subscribeToSourceTitle",
    value: function subscribeToSourceTitle(node, callback) {
      var _cachedData$data,
        _this4 = this;
      // check node is a sync block, as we only support sync block subscriptions
      if (node.type.name !== 'syncBlock') {
        return function () {};
      }
      var _node$attrs = node.attrs,
        resourceId = _node$attrs.resourceId,
        localId = _node$attrs.localId;
      if (!localId || !resourceId) {
        return function () {};
      }
      var cachedData = this.getFromCache(resourceId);
      if (cachedData !== null && cachedData !== void 0 && (_cachedData$data = cachedData.data) !== null && _cachedData$data !== void 0 && _cachedData$data.sourceTitle) {
        callback(cachedData.data.sourceTitle);
      }

      // add to subscriptions map
      var resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
      this.titleSubscriptions.set(resourceId, _objectSpread(_objectSpread({}, resourceSubscriptions), {}, _defineProperty({}, localId, callback)));
      return function () {
        var resourceSubscriptions = _this4.titleSubscriptions.get(resourceId);
        if (resourceSubscriptions) {
          delete resourceSubscriptions[localId];
          if (Object.keys(resourceSubscriptions).length === 0) {
            _this4.titleSubscriptions.delete(resourceId);
          } else {
            _this4.titleSubscriptions.set(resourceId, resourceSubscriptions);
          }
        }
      };
    }
  }, {
    key: "subscribe",
    value: function subscribe(node, callback) {
      // check node is a sync block, as we only support sync block subscriptions
      if (node.type.name !== 'syncBlock') {
        return function () {};
      }
      var _node$attrs2 = node.attrs,
        resourceId = _node$attrs2.resourceId,
        localId = _node$attrs2.localId;
      if (!localId || !resourceId) {
        return function () {};
      }
      return this.subscribeToSyncBlock(resourceId, localId, callback);
    }

    /**
     * Get the URL for a sync block.
     * @param resourceId - The resource ID of the sync block
     * @returns
     */
  }, {
    key: "getSyncBlockURL",
    value: function getSyncBlockURL(resourceId) {
      var _syncBlock$data;
      var syncBlock = this.getFromCache(resourceId);
      if (!syncBlock) {
        return undefined;
      }
      return (_syncBlock$data = syncBlock.data) === null || _syncBlock$data === void 0 ? void 0 : _syncBlock$data.sourceURL;
    }
  }, {
    key: "getProviderFactory",
    value: function getProviderFactory(resourceId) {
      if (!this.dataProvider) {
        return undefined;
      }
      var _this$dataProvider$ge = this.dataProvider.getSyncedBlockRendererProviderOptions(),
        parentDataProviders = _this$dataProvider$ge.parentDataProviders,
        providerCreator = _this$dataProvider$ge.providerCreator;
      var providerFactory = this.providerFactories.get(resourceId);
      if (!providerFactory) {
        providerFactory = ProviderFactory.create({
          mentionProvider: parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.mentionProvider,
          profilecardProvider: parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.profilecardProvider,
          taskDecisionProvider: parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.taskDecisionProvider
        });
        this.providerFactories.set(resourceId, providerFactory);
      }
      if (providerCreator) {
        this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
      }
      return providerFactory;
    }
  }, {
    key: "retrieveDynamicProviders",
    value: function retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
      var _syncBlock$data2, _syncBlock$data3, _syncBlock$data4, _syncBlock$data5;
      if (!this.dataProvider) {
        return;
      }
      var hasMediaProvider = providerFactory.hasProvider('mediaProvider');
      var hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
      if (hasMediaProvider && hasEmojiProvider) {
        return;
      }
      var syncBlock = this.getFromCache(resourceId);
      if (!syncBlock || !((_syncBlock$data2 = syncBlock.data) !== null && _syncBlock$data2 !== void 0 && _syncBlock$data2.sourceAri) || !((_syncBlock$data3 = syncBlock.data) !== null && _syncBlock$data3 !== void 0 && _syncBlock$data3.product)) {
        return;
      }
      var parentInfo = this.dataProvider.retrieveSyncBlockParentInfo((_syncBlock$data4 = syncBlock.data) === null || _syncBlock$data4 === void 0 ? void 0 : _syncBlock$data4.sourceAri, (_syncBlock$data5 = syncBlock.data) === null || _syncBlock$data5 === void 0 ? void 0 : _syncBlock$data5.product);
      if (!parentInfo) {
        return;
      }
      var contentId = parentInfo.contentId,
        contentProduct = parentInfo.contentProduct;
      if (!hasMediaProvider) {
        if (providerCreator.createMediaProvider && contentId && contentProduct) {
          var mediaProvider = providerCreator.createMediaProvider({
            contentProduct: contentProduct,
            contentId: contentId
          });
          if (mediaProvider) {
            providerFactory.setProvider('mediaProvider', mediaProvider);
          }
        }
      }
      if (!hasEmojiProvider) {
        if (providerCreator.createEmojiProvider && contentId && contentProduct) {
          var emojiProvider = providerCreator.createEmojiProvider({
            contentProduct: contentProduct,
            contentId: contentId
          });
          if (emojiProvider) {
            providerFactory.setProvider('emojiProvider', emojiProvider);
          }
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.dataProvider = undefined;
      this.syncBlockCache.clear();
      this.subscriptions.clear();
      this.titleSubscriptions.clear();
      this.syncBlockURLRequests.clear();
      this.providerFactories.clear();
      this.isRefreshingSubscriptions = false;
      this.providerFactories.forEach(function (providerFactory) {
        providerFactory.destroy();
      });
      this.providerFactories.clear();
    }
  }]);
}();